import get from 'lodash/get';

export const ResponseHelpers = {
  isStatusOk(status) {
    return status >= 200 && status <= 299;
  },

  isClientError(status) {
    return status >= 400 && status <= 499;
  },

  isServerError(status) {
    return status >= 500 && status <= 599;
  },

  isAborted(response) {
    return response.status === 0 && !response.statusText;
  },
};

/**
 * Status codes returned by the API
 */
export const HttpResponseCodes = {
  OK: 200,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  EXPECTATION_FAILED: 417,
  UNPROCESSABLE_ENTITY: 422,
  TOO_MANY_REQUESTS: 429,
  LIMIT_REACHED: 480,
  USER_BLOCKED: 481,
  UNAVAILABLE_PARENT: 482,
};

/**
 * Process response data to only return what is needed by the application.
 *
 * @param  {Object} response Original response from axios
 * @return {Object}          Filtered plain object
 */
export function processResponse(response) {
  return {
    status: response.status,
    statusText: response.statusText,
    ok: true,
    aborted: ResponseHelpers.isAborted(response),
    body: response.data,
  };
}

/**
 * Process original response error, keep only necessary data,
 * and throw again.
 *
 * @param  {Object} originalError Original response error from axios
 * @throws {Object}               Throws an error with the data expected by the aplication.
 */
export function processError(originalError) {
  const error = new Error(originalError.message);
  error.body = get(originalError, 'response.data', {});
  error.status = get(originalError, 'response.status', 0);
  error.statusText = get(originalError, 'response.statusText', '');
  error.ok = false;

  throw error;
}
